<template lang="pug">
  e-input-file-upload(
    v-model="file"
    ref="fileInput"
    can-delete
    :rules="rules"
    :name="$t('File')"
    :allowed-extensions="extensionsMap"
    :accept="acceptedFileExtensions"
  )
    template(v-slot:description)
      div(class="text-14px mb-6") {{ $t('Use the {formats} formats or our template', { formats: 'CSV, XLSX, XLS' }) }}
        span(
          class="upload-contact-file"
          @click="onClick"
        ) {{ $t('template') }}
</template>

<script>
import EInputFileUpload from '~/components/elements/inputs/e-input-file-upload'
import upload from '~/modules/contacts/mixins/upload'

export default {
  name: 'EInputContactUpload',
  components: { EInputFileUpload },
  mixins: [upload],
  data() {
    return {
      file: null
    }
  },
  watch: {
    file(file) {
      this.$emit('input', file)
    }
  },
  methods: {
    validate() {
      return this.$refs.fileInput.validate()
    },
    onClick() {
      const link = document.createElement('a')
      link.href = '/test.csv'
      link.download = 'template.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped lang="scss">
.upload-contact-file {
  padding-left: 6px;
  color: #8f257d;
  cursor: pointer;
}
</style>
